module.exports = __webpack_public_path__ + "img/pic_book.86bce09b.png";